document.addEventListener('DOMContentLoaded', function() {
  // Welcome Popup
  const showWelcomePopup = () => {
    if (!localStorage.getItem('popupShown')) {
      const popup = `
        <div class="welcome-popup">
          <div class="popup-content">
            <h3>🌿 Benvenuto nel Mondo della Tricologia Naturale</h3>
            <p>Usa il codice <strong>WELCOME2025</strong> per il 15% di sconto</p>
            <button class="btn-main" onclick="closePopup()">Scopri i Prodotti</button>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', popup);
      localStorage.setItem('popupShown', 'true');
    }
  };

  // Close Popup Function
  window.closePopup = function() {
    const popup = document.querySelector('.welcome-popup');
    if (popup) {
      popup.style.opacity = '0';
      setTimeout(() => popup.remove(), 300);
    }
  };

  // Add to Cart Animation
  const addToCartButtons = document.querySelectorAll('.add-to-cart');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function() {
      button.classList.add('clicked');
      setTimeout(() => button.classList.remove('clicked'), 300);
    });
  });

  // Initialize Popup after 3 seconds
  setTimeout(showWelcomePopup, 3000);
});
